import React from 'react';
import '../less/TextAboveFooter.less';
import {environment} from "../../../../environment/environment";


export default function template() {
    const { widget } = this.props;



    return (
          widget && widget?.data && widget?.data[0]?.desc_ua.length > 0 ? (
                <section>
                    <div className="content">
                        <div className='text-above-footer' dangerouslySetInnerHTML={{__html: widget.data[0].desc_ua}}>
                        </div>
                    </div>
                </section>
            ) : ''
    );
}
